var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 37,
    viewBox: "0 0 61 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8744 36.0554H19.8295L6.96769 19.8674H4.41751V36.0554H0.481368V1.23997C0.481368 1.23997 8.29822 1.23997 11.0147 1.23997C13.8421 1.23997 22.1579 2.2933 22.1579 9.94383C22.1579 17.0954 15.9488 19.0912 11.8463 19.6456L24.8744 36.0554ZM4.41751 2.12699V18.9803H7.46664C13.953 18.9803 17.9445 16.7628 17.9445 10.5537C17.9445 4.45541 14.5628 2.12699 8.90804 2.12699H4.41751ZM55.7793 36.0554L49.7364 22.0849H36.2094L29.9448 36.0554H28.7252L44.5252 0.574701H44.8024L60.048 36.0554H55.7793ZM36.5975 21.1424H49.3484L43.0838 6.56208L36.5975 21.1424Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRa);
export default __webpack_public_path__ + "static/media/ra.9ca02113b80e7edebf06603eadb2b5ed.svg";
export { ForwardRef as ReactComponent };